import axios from "@/lib/request";

const appHeaders = {
  AppKey: "BpLnfgDs"
};

export const getCompanyList = params =>
  axios.request({
    url: "/v1/admin/cmn/company/list",
    method: "get",
    params
  });

export const getCompanyInfo = params =>
  axios.request({
    url: "/v1/admin/cmn/company/info",
    method: "get",
    params,
    headers: appHeaders
  });

export const addCompany = data =>
  axios.request({
    url: "/v1/admin/cmn/company/add",
    method: "post",
    data
  });

export const updateCompany = data =>
  axios.request({
    url: "/v1/admin/cmn/company/update",
    method: "post",
    data
  });

export const getCompanyProvinceList = params =>
  axios.request({
    url: "/v1/admin/cmn/province/list",
    method: "get",
    params,
    headers: appHeaders
  });

export const getCompanyCityList = params =>
  axios.request({
    url: "/v1/admin/cmn/city/list",
    method: "get",
    params,
    headers: appHeaders
  });

export const uploadCompanyFile = data =>
  axios.request({
    url: "/res/file/upload",
    method: "post",
    data,
    headers: {
      ...appHeaders,
      "Content-Type": "multipart/form-data"
    }
  });
